'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const WhatsNewIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="WhatsNewIcon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_297_4611)">
          <path
            d="M16.784 13.8119L15.899 14.5819L18.399 22.0919C18.4325 22.1925 18.4331 22.3012 18.4007 22.4022C18.3683 22.5032 18.3047 22.5912 18.219 22.6537C18.1333 22.7161 18.0299 22.7497 17.9239 22.7496C17.8178 22.7494 17.7146 22.7156 17.629 22.6529L11.4 18.0819L5.16604 22.6529C5.0805 22.7156 4.97724 22.7494 4.8712 22.7496C4.76515 22.7497 4.66181 22.7161 4.5761 22.6537C4.49039 22.5912 4.42675 22.5032 4.39439 22.4022C4.36202 22.3012 4.3626 22.1925 4.39604 22.0919L6.89604 14.5819L0.925039 9.1299C0.847356 9.06347 0.791899 8.97482 0.766139 8.87591C0.740379 8.77699 0.745553 8.67256 0.780965 8.57667C0.816377 8.48079 0.880325 8.39806 0.964194 8.33963C1.04806 8.28121 1.14782 8.24989 1.25004 8.2499H8.40004L10.934 1.5739C10.97 1.47903 11.034 1.39736 11.1175 1.33972C11.201 1.28209 11.3001 1.25122 11.4015 1.25122C11.503 1.25122 11.6021 1.28209 11.6856 1.33972C11.7691 1.39736 11.8331 1.47903 11.869 1.5739L12.343 2.8259"
            stroke={sx?.color || '#3D517B'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M23.25 5.75C23.25 5.61739 23.1973 5.49021 23.1036 5.39645C23.0098 5.30268 22.8826 5.25 22.75 5.25H20.25V2.75C20.25 2.61739 20.1973 2.49021 20.1036 2.39645C20.0098 2.30268 19.8826 2.25 19.75 2.25H17.75C17.6174 2.25 17.4902 2.30268 17.3964 2.39645C17.3027 2.49021 17.25 2.61739 17.25 2.75V5.25H14.75C14.6174 5.25 14.4902 5.30268 14.3964 5.39645C14.3027 5.49021 14.25 5.61739 14.25 5.75V7.75C14.25 7.88261 14.3027 8.00979 14.3964 8.10355C14.4902 8.19732 14.6174 8.25 14.75 8.25H17.25V10.75C17.25 10.8826 17.3027 11.0098 17.3964 11.1036C17.4902 11.1973 17.6174 11.25 17.75 11.25H19.75C19.8826 11.25 20.0098 11.1973 20.1036 11.1036C20.1973 11.0098 20.25 10.8826 20.25 10.75V8.25H22.75C22.8826 8.25 23.0098 8.19732 23.1036 8.10355C23.1973 8.00979 23.25 7.88261 23.25 7.75V5.75Z"
            stroke={sx?.color || '#3D517B'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </SvgIcon>
  )
}

WhatsNewIcon.propTypes = {
  sx: PropTypes.object
}
